export const isEn = (language: string) => language === 'en'

export const transformBreadcrumbTitle = (title: string) => {
  if (!title) {
    return ''
  }

  return ['esg'].includes(title.toLowerCase())
    ? title.toUpperCase()
    : `${title.charAt(0).toUpperCase()}${title.slice(1)}`
}
